import { ColorStock } from "../Components/TitleBadge/TitleBadge.types";
import { SelectedOption, ShopifyProductOption, StyleMatrix, ValidStyle } from "./interfaces";

export const getStockOrder = (stock: ColorStock[]) => {
    stock.sort((a, b) => parseFloat(b.stock) - parseFloat(a.stock));
    return stock.map((item) => {
        return item.color;
    });
};

export const findOption = (
    options: ShopifyProductOption[],
    name: string
) => options.find(option => option.name === name);

export const getValidStyles = (title: string) => {
    const wordArray = title.split(' ');

    const stylesMatrix: StyleMatrix[] = [
        { type: 'Shield', lines: [14, 16] },
        { type: 'R-End', lines: [20] },
        { type: 'R-Cnr', lines: [20, 20] },
        { type: 'Bar', lines: [20] },
        { type: '20mm Star', lines: [10, 7] },
        { type: '30mm Star', lines: [12, 8] },
        { type: '20mm Disc', lines: [9, 9] },
        { type: '30mm Disc', lines: [12, 12] }
    ];

    const validStyles: ValidStyle[] = [];

    const isValid = (type: string, lines: number[]) => {
        let firstLineWordCount = 0;
        let secondLineWordCount = 0;
        let lineCount = 1;
        const firstLine = lines[0];
        const secondLine = lines[1];
        let firstLineCharCount = 0;
        let secondLineCharCount = 0;
        
        for (let i = 0; i < wordArray.length; i++) {
        // wordArray.forEach(word => {
            const word = wordArray[i];
            firstLineWordCount++;
            const strLength = word.length;
            if (firstLineWordCount === 1 && lineCount === 1) { // IF first word let's store the str length
                firstLineCharCount += strLength;
                if (firstLineCharCount > firstLine) {
                    return false;
                }
            } else {
                const newCharCount = strLength + 1; // If it's not the first word then we need to append a space
                firstLineCharCount += newCharCount;
            }

            if (firstLineCharCount > firstLine) {
                if (lines.length === 1) {
                    return false; // char count has exceeded the first line limit
                } else {
                    // We are now on line 2
                    lineCount = 2;
                    secondLineWordCount++;
                    /* DON'T THINK WE'LL NEED THIS */
                    if (lineCount > lines.length) {
                        return false;
                    }
                    /* END */
                    if (secondLineWordCount === 1) {
                        secondLineCharCount += strLength;
                    } else {
                        secondLineCharCount += strLength + 1;
                    }
                    
                    if (secondLineCharCount > secondLine) {
                        return false; // char count has exceeded the second line limit
                    }
                }
            }
        };
        return true;
        
    }

    stylesMatrix.forEach(({
        type,
        lines
    }: StyleMatrix) => {        
        validStyles.push({
            type,
            valid: isValid(type, lines),
        });
    });
    return validStyles;
};